var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page--banner"},[_c('div',{staticClass:"title--text"},[_vm._v(" "+_vm._s(_vm.$t(_vm.bannerText))+" ")]),_c('img',{staticClass:"banner--image",attrs:{"src":require("@/assets/img/home/banner-2.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }